import { Link } from 'react-router-dom';
import { Stack } from '@mui/material';
import {
  Edit as EditIcon,
  Archive as ArchiveIcon,
  Publish as PublishIcon,
} from '@mui/icons-material';

import { Button, DeleteForeverOutlinedIcon } from '@occc/ui-design-system';
import { Kiosk_Ad_Set_Status } from '@occc/graphql';

type AdSetActionsProps = {
  editUrl: string;
  status: Kiosk_Ad_Set_Status;
  onDelete: () => void;
  onPublish: () => void;
  onArchive: () => void;
};

export const AdSetActions = ({
  editUrl,
  status,
  onDelete,
  onPublish,
  onArchive,
}: AdSetActionsProps) => {
  const isDraft = status === Kiosk_Ad_Set_Status.Draft;
  const isPublished = status === Kiosk_Ad_Set_Status.Published;
  const isArchived = status === Kiosk_Ad_Set_Status.Archived;

  return (
    <Stack direction='row' spacing={1}>
      <Button
        variant='outlined'
        color='secondary'
        startIcon={<DeleteForeverOutlinedIcon />}
        onClick={onDelete}
      >
        Delete
      </Button>

      <Button
        variant='outlined'
        color='secondary'
        startIcon={<EditIcon />}
        component={Link}
        to={editUrl}
      >
        Edit
      </Button>

      {(isDraft || isArchived) && (
        <Button
          variant='contained'
          color='secondary'
          startIcon={<PublishIcon />}
          onClick={onPublish}
        >
          Publish
        </Button>
      )}

      {isPublished && (
        <Button
          variant='contained'
          color='secondary'
          startIcon={<ArchiveIcon />}
          onClick={onArchive}
        >
          Archive
        </Button>
      )}
    </Stack>
  );
};
